import { SERVICES, SERVICE_GROUPS } from '@shared';
import { ServiceCard } from '../components/ServiceCard';
import { useSeo } from '../lib/seo';

export function Services() {
  useSeo({
    title: 'Services — 22 B2B service lines · Omega Trade and Finance',
    description: 'Twenty-two B2B service lines across trade instruments, capital introductions, projects, research and corporate services. From 2%, multi-currency, body-corporate clients only.',
    canonicalPath: '/services',
  });
  return (
    <main>
      <section className="section" style={{ paddingBottom: 0 }}>
        <div className="container">
          <span className="eyebrow">Service portfolio</span>
          <h1 style={{ fontSize: 'clamp(40px, 6vw, 72px)', letterSpacing: '-0.025em', marginTop: 18, maxWidth: '14ch' }}>
            Twenty-two service lines, five practice areas.
          </h1>
          <p className="lead" style={{ marginTop: 18, maxWidth: '60ch' }}>
            Every service framed as consultancy, research, document preparation or pure introducer
            activity. Available exclusively to body corporates self-certifying as sophisticated.
          </p>
        </div>
      </section>

      <section style={{ paddingBlock: 'var(--section-y)' }}>
        <div className="container">
          {SERVICE_GROUPS.map((g, i) => {
            const list = SERVICES.filter((s) => s.group === g.id);
            return (
              <div key={g.id} className="svc-group">
                <div className="svc-group-hd">
                  <div>
                    <span className="eyebrow">
                      <span style={{ color: 'var(--accent)' }}>{String(i + 1).padStart(2, '0')}</span> Practice area
                    </span>
                    <h3 style={{ marginTop: 12 }}>{g.label}</h3>
                  </div>
                  <p>{g.blurb}</p>
                </div>
                <div className="svc-grid">
                  {list.map((s) => <ServiceCard key={s.id} svc={s} />)}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
}
